/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!******************!*\
  !*** multi main ***!
  \******************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./js/index */8);


/***/ },
/* 1 */
/*!************************!*\
  !*** ./images/owl.png ***!
  \************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2 */
/*!*******************!*\
  !*** ./js/app.js ***!
  \*******************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.app = undefined;
	
	var _tweet = __webpack_require__(/*! ../sounds/tweet.mp3 */ 14);
	
	var _tweet2 = _interopRequireDefault(_tweet);
	
	var _ding = __webpack_require__(/*! ../sounds/ding.mp3 */ 13);
	
	var _ding2 = _interopRequireDefault(_ding);
	
	var _owl = __webpack_require__(/*! ../images/owl.png */ 1);
	
	var _owl2 = _interopRequireDefault(_owl);
	
	var _settings = __webpack_require__(/*! ./settings */ 10);
	
	var _animationControl = __webpack_require__(/*! ./animation-control */ 6);
	
	var _clockContainer = __webpack_require__(/*! ./clock-container */ 3);
	
	var _modal = __webpack_require__(/*! ./modal */ 9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DIM_CSS_CLASS = 'dim';
	
	var settings = new _settings.Settings();
	_clockContainer.clockContainer.updateOpacity(settings.clockOpacity);
	
	var messageElement = void 0;
	var audioBreakStartEl = void 0;
	var audioBreakOverEl = void 0;
	
	var owlSvg = void 0;
	
	var clock = void 0;
	var timeElapsed = 0;
	
	var WORK_MESSAGE = 'Leave this running...';
	
	var start = function start() {
	  findElements();
	  _modal.modal.show();
	};
	
	var startContinue = function startContinue() {
	  requestPermission();
	};
	
	var handleNotificationDenied = function handleNotificationDenied() {
	  dim();
	  messageElement.innerHTML = 'Please allow notifications to use Eye Hoot.';
	};
	
	var requestPermission = function requestPermission() {
	  if (window.Notification && Notification.permission !== 'denied') {
	    Notification.requestPermission(function (status) {
	      if (status === 'granted') {
	        startWork();
	      } else {
	        handleNotificationDenied();
	      }
	    });
	  } else {
	    handleNotificationDenied();
	  }
	};
	
	var findElements = function findElements() {
	  messageElement = document.querySelector('.message');
	
	  audioBreakOverEl = document.querySelector('.break-over');
	  audioBreakOverEl.src = _ding2.default;
	  audioBreakStartEl = document.querySelector('.break-start');
	  audioBreakStartEl.src = _tweet2.default;
	
	  owlSvg = document.querySelector('.owl-svg');
	};
	
	var updateMessage = function updateMessage(message) {
	  messageElement.innerHTML = message;
	};
	
	var dim = function dim() {
	  [owlSvg, messageElement].forEach(function (el) {
	    return el.classList.add(DIM_CSS_CLASS);
	  });
	};
	
	var brighten = function brighten() {
	  [owlSvg, messageElement].forEach(function (el) {
	    if (el.classList.contains(DIM_CSS_CLASS)) {
	      el.classList.remove(DIM_CSS_CLASS);
	    }
	  });
	};
	
	var startAnimation = function startAnimation() {
	  brighten();
	  _animationControl.animationControl.playAnimation();
	  updateMessage(_animationControl.animationControl.getAnimationMessage());
	};
	
	var stopAnimation = function stopAnimation() {
	  _animationControl.animationControl.stopAnimation();
	};
	
	var startLongBreakAnimation = function startLongBreakAnimation() {
	  brighten();
	  _animationControl.animationControl.startStopLongBreakAnimation();
	  updateMessage(_animationControl.animationControl.longBreakAnimationMessage);
	};
	
	var stopBreakAnimation = function stopBreakAnimation() {
	  _animationControl.animationControl.startStopLongBreakAnimation();
	};
	
	var notify = function notify(message) {
	  var n = new Notification('Eye Hoot', {
	    body: message,
	    icon: _owl2.default,
	    requireInteraction: true
	  });
	  playSound(audioBreakStartEl);
	  n.onclick = notificationClickedHandler.bind(n);
	};
	
	var notificationClickedHandler = function notificationClickedHandler() {
	  window.focus();
	  this.close();
	  settings.close();
	  if (timeElapsed < settings.longBreakInterval) {
	    startAnimation();
	    startAnimationClock(settings.eyeExerciseDuration);
	  } else {
	    startLongBreakAnimation();
	    startAnimationClock(settings.longBreakDuration);
	  }
	};
	
	var playSound = function playSound(element) {
	  if (settings.soundEnabled) {
	    element.play();
	  }
	};
	
	var startAnimationClock = function startAnimationClock(interval) {
	  clock = $('.clock').FlipClock(interval, {
	    clockFace: 'MinuteCounter',
	    countdown: true,
	    callbacks: {
	      stop: stopAnimationClockHandler
	    }
	  });
	};
	
	var stopAnimationClockHandler = function stopAnimationClockHandler() {
	  if (timeElapsed < settings.longBreakInterval) {
	    stopAnimation();
	    timeElapsed = timeElapsed + settings.eyeExerciseDuration + settings.eyeExerciseInterval;
	    console.debug('stopClockHandler: timeElapsed = ' + timeElapsed);
	  } else {
	    stopBreakAnimation();
	    timeElapsed = 0;
	  }
	  playSound(audioBreakOverEl);
	  startWork();
	};
	
	var startWork = function startWork() {
	  updateMessage(WORK_MESSAGE);
	  dim();
	  startWorkClock();
	};
	
	var startWorkClock = function startWorkClock() {
	  if (clock) {
	    clock.reset(); // clear old callbacks
	  }
	  clock = $('.clock').FlipClock(settings.eyeExerciseInterval, {
	    clockFace: 'MinuteCounter',
	    countdown: true,
	    callbacks: {
	      stop: stopWorkClockHandler
	    }
	  });
	};
	
	var stopWorkClockHandler = function stopWorkClockHandler() {
	  var notifyBody = timeElapsed < settings.longBreakInterval ? 'Time for a short break' : 'Time for a long break';
	  notify(notifyBody);
	};
	
	// public api
	var app = {
	  start: start,
	  startContinue: startContinue,
	  startWork: startWork
	};
	
	exports.app = app;

/***/ },
/* 3 */
/*!*******************************!*\
  !*** ./js/clock-container.js ***!
  \*******************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var clockContainerEl = document.querySelector('.clock-container');
	
	var updateOpacity = function updateOpacity(opacity) {
	  clockContainerEl.style.opacity = opacity;
	};
	
	// public api
	var clockContainer = {
	  updateOpacity: updateOpacity
	};
	
	exports.clockContainer = clockContainer;

/***/ },
/* 4 */
/*!**************************!*\
  !*** ./js/controller.js ***!
  \**************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.controller = undefined;
	
	var _app = __webpack_require__(/*! ./app */ 2);
	
	var _clockContainer = __webpack_require__(/*! ./clock-container */ 3);
	
	var update = function update(key, val) {
	  switch (key) {
	    case 'introModalClosed':
	      _app.app.startContinue();
	      break;
	    case '_eyeExerciseInterval':
	      _app.app.startWork();
	      break;
	    case '_clockOpacity':
	      _clockContainer.clockContainer.updateOpacity(val);
	    default:
	      break;
	  }
	};
	
	// public api
	var controller = {
	  update: update
	};
	
	exports.controller = controller;

/***/ },
/* 5 */
/*!***************************!*\
  !*** ./js/persistence.js ***!
  \***************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APP_KEY = 'eyehoot';
	
	var storageAvailable = function storageAvailable(type) {
	  try {
	    var storage = window[type],
	        x = '__storage_test__';
	    storage.setItem(x, x);
	    storage.removeItem(x);
	    return true;
	  } catch (e) {
	    return false;
	  }
	};
	
	var localStorageAvailable = storageAvailable('localStorage');
	
	var saveItem = function saveItem(key, value) {
	  localStorage.setItem(APP_KEY + '-' + key, value);
	};
	
	var save = function save(key, value) {
	  if (localStorageAvailable) {
	    saveItem(key, value);
	  }
	};
	
	var retrieveItem = function retrieveItem(key) {
	  return localStorage.getItem(APP_KEY + '-' + key);
	};
	
	var retrieve = function retrieve(key, defaultVal) {
	  if (localStorageAvailable) {
	    var result = retrieveItem(key);
	    return result == undefined ? defaultVal : result;
	  } else {
	    return defaultVal;
	  }
	};
	
	var removeAll = function removeAll() {
	  if (localStorageAvailable) {
	    localStorage.clear();
	  }
	};
	
	var exists = function exists(key) {
	  var result = retrieveItem(key);
	  return result == undefined ? false : true;
	};
	
	// public api
	var persistence = {
	  save: save,
	  retrieve: retrieve,
	  removeAll: removeAll,
	  exists: exists
	};
	
	exports.persistence = persistence;

/***/ },
/* 6 */
/*!*********************************!*\
  !*** ./js/animation-control.js ***!
  \*********************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var windowSvg = document.querySelector('.window-svg');
	var owlGraphic = document.querySelector('.owl-graphic');
	var eyes = document.querySelector('.eyes');
	var leftEyeShine = document.querySelector('.left-eye-shine');
	var rightEyeShine = document.querySelector('.right-eye-shine');
	var leftWing = document.querySelector('.left-wing');
	var rightWing = document.querySelector('.right-wing');
	var feet = document.querySelectorAll('.foot');
	var leftFoot = document.querySelector('.left-foot');
	var rightFoot = document.querySelector('.right-foot');
	
	var animationIndex = 0;
	
	var init = function init() {
	  // As of Chrome 64, percentage based transforms work the same way as Firefox
	  document.body.classList.add('ff');
	
	  // owl-graphic: transform-origin: center bottom
	  var owlGraphicBbox = owlGraphic.getBBox();
	  var owlGraphicToX = owlGraphicBbox.x + owlGraphicBbox.width / 2;
	  var owlGraphicToY = owlGraphicBbox.y + owlGraphicBbox.height;
	  owlGraphic.style['transform-origin'] = owlGraphicToX + 'px ' + owlGraphicToY + 'px';
	
	  // eyes transform-origin: 50% 50%
	  var eyesBbox = eyes.getBBox();
	  var eyesToX = eyesBbox.x + eyesBbox.width / 2;
	  var eyesToY = eyesBbox.y + eyesBbox.height / 2;
	  eyes.style['transform-origin'] = eyesToX + 'px ' + eyesToY + 'px';
	
	  // left-wing transform-origin: right top
	  var leftWingBbox = leftWing.getBBox();
	  var leftWingToX = leftWingBbox.x + leftWingBbox.width;
	  var leftWingToY = leftWingBbox.y;
	  leftWing.style['transform-origin'] = leftWingToX + 'px ' + leftWingToY + 'px';
	
	  // right-wing transform-origin: left top
	  var rightWingBbox = rightWing.getBBox();
	  var rightWingToX = rightWingBbox.x;
	  var rightWingToY = rightWingBbox.y;
	  rightWing.style['transform-origin'] = rightWingToX + 'px ' + rightWingToY + 'px';
	
	  // foot transform-origin: center top
	  for (var i = 0; i < feet.length; i++) {
	    var footEl = feet[i];
	    var footBbox = footEl.getBBox();
	    var footToX = footBbox.x + footBbox.width / 2;
	    var footToY = footBbox.y;
	    footEl.style['transform-origin'] = footToX + 'px ' + footToY + 'px';
	  }
	};
	
	var sideToSide = function sideToSide() {
	  eyes.classList.toggle('side-to-side');
	  leftEyeShine.classList.toggle('side-to-side');
	  rightEyeShine.classList.toggle('side-to-side');
	};
	
	var upDown = function upDown() {
	  eyes.classList.toggle('up-down');
	  leftEyeShine.classList.toggle('up-down');
	  rightEyeShine.classList.toggle('up-down');
	};
	
	var aroundRight = function aroundRight() {
	  eyes.classList.toggle('around-right');
	  leftEyeShine.classList.toggle('around-right');
	  rightEyeShine.classList.toggle('around-right');
	};
	
	var aroundLeft = function aroundLeft() {
	  eyes.classList.toggle('around-left');
	  leftEyeShine.classList.toggle('around-left');
	  rightEyeShine.classList.toggle('around-left');
	};
	
	var blinkEyes = function blinkEyes() {
	  eyes.classList.toggle('blink');
	};
	
	var farFocus = function farFocus() {
	  windowSvg.classList.toggle('window-visible');
	};
	
	var coverEyes = function coverEyes() {
	  rightWing.classList.toggle('forward-up');
	  leftWing.classList.toggle('forward-up');
	};
	
	var longBreak = function longBreak() {
	  owlGraphic.classList.toggle('wobble');
	  leftWing.classList.toggle('flap-left');
	  rightWing.classList.toggle('flap-right');
	  rightFoot.classList.toggle('march');
	  leftFoot.classList.toggle('march');
	};
	
	var EYE_ANIMATIONS = [sideToSide, aroundLeft, coverEyes, upDown, aroundRight, blinkEyes, farFocus];
	
	var EYE_ANIMATIONS_MESSAGES = ['Move your eyes from side to side', 'Move your eyes around to the left', 'Cover your eyes', 'Move your eyes up and down', 'Move your eyes around to the right', 'Open and close your eyes', 'Look out a window or far away object'];
	
	var longBreakAnimationMessage = 'Get up and go for for a walk';
	
	var playAnimation = function playAnimation() {
	  EYE_ANIMATIONS[animationIndex]();
	};
	
	var stopAnimation = function stopAnimation() {
	  EYE_ANIMATIONS[animationIndex]();
	  animationIndex = animationIndex === EYE_ANIMATIONS.length - 1 ? 0 : animationIndex + 1;
	};
	
	var getAnimationMessage = function getAnimationMessage() {
	  return EYE_ANIMATIONS_MESSAGES[animationIndex];
	};
	
	var startStopLongBreakAnimation = function startStopLongBreakAnimation() {
	  longBreak();
	};
	
	// public api
	var animationControl = {
	  playAnimation: playAnimation,
	  stopAnimation: stopAnimation,
	  getAnimationMessage: getAnimationMessage,
	  startStopLongBreakAnimation: startStopLongBreakAnimation,
	  longBreakAnimationMessage: longBreakAnimationMessage
	};
	
	init();
	
	exports.animationControl = animationControl;

/***/ },
/* 7 */
/*!**************************!*\
  !*** ./js/conversion.js ***!
  \**************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SECONDS_IN_MINUTE = 60;
	
	var secondsToMinutes = function secondsToMinutes(val) {
	  return val / SECONDS_IN_MINUTE;
	};
	
	var minutesToSeconds = function minutesToSeconds(val) {
	  return val * SECONDS_IN_MINUTE;
	};
	
	var stringToBoolean = function stringToBoolean(val) {
	  return val === 'true' ? true : false;
	};
	
	var stringToInt = function stringToInt(val) {
	  var result = parseInt(val, 10);
	  if (!isNaN(result)) {
	    return result;
	  } else {
	    throw new Error('Expected numeric integer setting');
	  }
	};
	
	var stringToFloat = function stringToFloat(val) {
	  var result = parseFloat(val);
	  if (!isNaN(result)) {
	    return result;
	  } else {
	    throw new Error('Expected numeric float setting');
	  }
	};
	
	// public api
	var conversion = {
	  secondsToMinutes: secondsToMinutes,
	  minutesToSeconds: minutesToSeconds,
	  stringToBoolean: stringToBoolean,
	  stringToInt: stringToInt,
	  stringToFloat: stringToFloat
	};
	
	exports.conversion = conversion;

/***/ },
/* 8 */
/*!*********************!*\
  !*** ./js/index.js ***!
  \*********************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _app = __webpack_require__(/*! ./app */ 2);
	
	__webpack_require__(/*! ../css/styles.scss */ 12);
	__webpack_require__(/*! ../images/owl.png */ 1);
	
	document.addEventListener('DOMContentLoaded', _app.app.start);

/***/ },
/* 9 */
/*!*********************!*\
  !*** ./js/modal.js ***!
  \*********************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modal = undefined;
	
	var _controller = __webpack_require__(/*! ./controller */ 4);
	
	var _persistence = __webpack_require__(/*! ./persistence */ 5);
	
	var _owl = __webpack_require__(/*! ../images/owl.png */ 1);
	
	var _owl2 = _interopRequireDefault(_owl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HAS_SEEN_INTRO_KEY = 'hasSeenIntro';
	
	var modalEl = document.querySelector('#modal');
	var modalOverlayEl = document.querySelector('#modalOverlay');
	var modalCloseEl = document.querySelector('#modalClose');
	var modalStartEl = document.querySelector('#modalStart');
	var modalLogoEl = document.querySelector('#modalLogo');
	
	modalLogoEl.src = _owl2.default;
	modalCloseEl.addEventListener('click', function () {
	  return close();
	});
	modalStartEl.addEventListener('click', function () {
	  return close();
	});
	
	var show = function show() {
	  if (!_hasSeenIntro()) {
	    open();
	    _persistence.persistence.save(HAS_SEEN_INTRO_KEY, true);
	  } else {
	    _controller.controller.update('introModalClosed');
	  }
	};
	
	var open = function open() {
	  modalEl.classList.toggle('closed');
	  modalOverlayEl.classList.toggle('closed');
	};
	
	var close = function close() {
	  modalEl.classList.toggle('closed');
	  modalOverlayEl.classList.toggle('closed');
	  _controller.controller.update('introModalClosed');
	};
	
	var _hasSeenIntro = function _hasSeenIntro() {
	  return _persistence.persistence.exists(HAS_SEEN_INTRO_KEY);
	};
	
	// public api
	var modal = {
	  show: show,
	  open: open,
	  close: close
	};
	
	exports.modal = modal;

/***/ },
/* 10 */
/*!************************!*\
  !*** ./js/settings.js ***!
  \************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Settings = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _persistence = __webpack_require__(/*! ./persistence */ 5);
	
	var _conversion = __webpack_require__(/*! ./conversion */ 7);
	
	var _validation = __webpack_require__(/*! ./validation */ 11);
	
	var _controller = __webpack_require__(/*! ./controller */ 4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_SOUND_ENABLED = 'true';
	var DEFAULT_CLOCK_OPACITY = '1';
	var SETTINGS_HIDDEN_CLASS = 'settings-hidden';
	
	var containerEl = document.querySelector('.settings-container');
	var eyeExerciseIntervalEl = document.getElementsByName('eyeExerciseInterval')[0];
	var longBreakIntervalEl = document.getElementsByName('longBreakInterval')[0];
	var longBreakDurationEl = document.getElementsByName('longBreakDuration')[0];
	var soundEnabledEl = document.getElementById('soundEnabled');
	var clockOpacityEl = document.getElementById('clockOpacity');
	var closeSettingsEl = document.getElementById('settingsClose');
	var openSettingsEl = document.getElementById('settingsOpen');
	var restoreSettingsEl = document.getElementById('restoreSettings');
	
	var Settings = exports.Settings = function () {
	  function Settings() {
	    _classCallCheck(this, Settings);
	
	    this._init();
	    this._registerEvents();
	    this._populateFields();
	  }
	
	  _createClass(Settings, [{
	    key: '_init',
	    value: function _init() {
	      this._eyeExerciseDuration = (15);
	      this._eyeExerciseInterval = _conversion.conversion.stringToInt(_persistence.persistence.retrieve('_eyeExerciseInterval', (900)));
	      this._longBreakInterval = _conversion.conversion.stringToInt(_persistence.persistence.retrieve('_longBreakInterval', (3600)));
	      this._longBreakDuration = _conversion.conversion.stringToInt(_persistence.persistence.retrieve('_longBreakDuration', (300)));
	      this._soundEnabled = _conversion.conversion.stringToBoolean(_persistence.persistence.retrieve('_soundEnabled', DEFAULT_SOUND_ENABLED));
	      this._clockOpacity = _conversion.conversion.stringToFloat(_persistence.persistence.retrieve('_clockOpacity', DEFAULT_CLOCK_OPACITY));
	    }
	  }, {
	    key: '_registerEvents',
	    value: function _registerEvents() {
	      var _this = this;
	
	      // numeric inputs
	      eyeExerciseIntervalEl.addEventListener('blur', function () {
	        return _this._numericChangeHandler(eyeExerciseIntervalEl, '_eyeExerciseInterval');
	      });
	      eyeExerciseIntervalEl.addEventListener('keypress', function (evt) {
	        return _this._keyPressHandler(eyeExerciseIntervalEl, '_eyeExerciseInterval', evt);
	      });
	      longBreakIntervalEl.addEventListener('blur', function () {
	        return _this._numericChangeHandler(longBreakIntervalEl, '_longBreakInterval');
	      });
	      longBreakIntervalEl.addEventListener('keypress', function (evt) {
	        return _this._keyPressHandler(longBreakIntervalEl, '_longBreakInterval', evt);
	      });
	      longBreakDurationEl.addEventListener('blur', function () {
	        return _this._numericChangeHandler(longBreakDurationEl, '_longBreakDuration');
	      });
	      longBreakDurationEl.addEventListener('keypress', function (evt) {
	        return _this._keyPressHandler(longBreakDurationEl, '_longBreakDuration', evt);
	      });
	      // checkboxes
	      soundEnabledEl.addEventListener('change', function () {
	        return _this._booleanChangeHandler(soundEnabledEl, '_soundEnabled');
	      });
	      // ranges
	      clockOpacityEl.addEventListener('input', function () {
	        return _this._rangeChangeHandler(clockOpacityEl, '_clockOpacity');
	      });
	      // buttons
	      closeSettingsEl.addEventListener('click', function () {
	        return _this.close();
	      });
	      openSettingsEl.addEventListener('click', function () {
	        return _this._open();
	      });
	      restoreSettingsEl.addEventListener('click', function (evt) {
	        return _this._restore(evt);
	      });
	    }
	  }, {
	    key: '_populateFields',
	    value: function _populateFields() {
	      eyeExerciseIntervalEl.value = _conversion.conversion.secondsToMinutes(this._eyeExerciseInterval);
	      longBreakIntervalEl.value = _conversion.conversion.secondsToMinutes(this._longBreakInterval);
	      longBreakDurationEl.value = _conversion.conversion.secondsToMinutes(this._longBreakDuration);
	      clockOpacity.value = this._clockOpacity;
	      soundEnabledEl.checked = this._soundEnabled;
	    }
	  }, {
	    key: '_numericChangeHandler',
	    value: function _numericChangeHandler(element, property) {
	      var isValid = true;
	      var newVal = element.value;
	      var currentVal = _conversion.conversion.secondsToMinutes(this[property]).toString();
	      if (newVal !== currentVal) {
	        if (_validation.validation.isValidNumber(newVal, parseInt(element.min, 10), parseInt(element.max, 10))) {
	          this[property] = _conversion.conversion.minutesToSeconds(newVal);
	          _persistence.persistence.save(property, this[property]);
	          _validation.validation.markElementValid(element);
	          _controller.controller.update(property);
	        } else {
	          isValid = false;
	          _validation.validation.markElementInvalid(element);
	        }
	      } else {
	        _validation.validation.clearMarkers(element);
	      }
	      return isValid;
	    }
	  }, {
	    key: '_keyPressHandler',
	    value: function _keyPressHandler(element, property, evt) {
	      if (evt.keyCode === 13) {
	        var isValid = this._numericChangeHandler(element, property);
	        if (!isValid) {
	          element.focus();
	        } else {
	          element.blur();
	        }
	      }
	    }
	  }, {
	    key: '_booleanChangeHandler',
	    value: function _booleanChangeHandler(element, property) {
	      var newVal = element.checked;
	      if (newVal !== this[property]) {
	        this[property] = newVal;
	        _persistence.persistence.save(property, this[property]);
	      }
	    }
	  }, {
	    key: '_rangeChangeHandler',
	    value: function _rangeChangeHandler(element, property) {
	      var newVal = element.value;
	      _controller.controller.update(property, newVal);
	      this[property] = newVal;
	      _persistence.persistence.save(property, this[property]);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (!containerEl.classList.contains(SETTINGS_HIDDEN_CLASS)) {
	        containerEl.classList.add(SETTINGS_HIDDEN_CLASS);
	      }
	    }
	  }, {
	    key: '_open',
	    value: function _open() {
	      containerEl.classList.remove(SETTINGS_HIDDEN_CLASS);
	    }
	  }, {
	    key: '_restore',
	    value: function _restore(evt) {
	      evt.preventDefault();
	
	      _persistence.persistence.removeAll();
	      this._init();
	      this._populateFields();
	
	      _controller.controller.update('_eyeExerciseInterval', this._eyeExerciseInterval);
	      _controller.controller.update('_clockOpacity', this._clockOpacity);
	    }
	  }, {
	    key: 'eyeExerciseInterval',
	    get: function get() {
	      return this._eyeExerciseInterval;
	    }
	  }, {
	    key: 'longBreakInterval',
	    get: function get() {
	      return this._longBreakInterval;
	    }
	  }, {
	    key: 'eyeExerciseDuration',
	    get: function get() {
	      return this._eyeExerciseDuration;
	    }
	  }, {
	    key: 'longBreakDuration',
	    get: function get() {
	      return this._longBreakDuration;
	    }
	  }, {
	    key: 'soundEnabled',
	    get: function get() {
	      return this._soundEnabled;
	    }
	  }, {
	    key: 'clockOpacity',
	    get: function get() {
	      return this._clockOpacity;
	    }
	  }]);

	  return Settings;
	}();

/***/ },
/* 11 */
/*!**************************!*\
  !*** ./js/validation.js ***!
  \**************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var svgValidEl = document.querySelector('.check-svg');
	var svgValidSize = svgValidEl.getClientRects()[0];
	var SVG_VALID_MARK_WIDTH = svgValidSize.width;
	var SVG_VALID_MARK_HALF_HEIGHT = svgValidSize.height / 2;
	var SVG_VALID_MARK_WIDTH_ADJUSTMENT = 3;
	var SVG_VALID_MARK_HEIGHT_ADJUSTMENT = 5;
	
	var ERROR_CSS_CLASS = 'settings-input-error';
	var VISIBLE_CSS_CLASS = 'visible';
	
	var isValidNumber = function isValidNumber(val, min, max) {
	  var isNumeric = /^(?:[1-9]\d*|0)$/.test(val);
	  var intVal = parseInt(val, 10);
	  return isNumeric && intVal >= min && intVal <= max;
	};
	
	var markElementInvalid = function markElementInvalid(element) {
	  element.classList.add(ERROR_CSS_CLASS);
	};
	
	var clearMarkers = function clearMarkers(element) {
	  if (element.classList.contains(ERROR_CSS_CLASS)) {
	    element.classList.remove(ERROR_CSS_CLASS);
	  }
	};
	
	var _positionValidMark = function _positionValidMark(element) {
	  var inputWrapper = element.parentElement;
	  var wrapperWidth = inputWrapper.clientWidth;
	  var wrapperLeft = inputWrapper.offsetLeft;
	  var wrapperHeight = inputWrapper.clientHeight;
	  var wrapperTop = inputWrapper.offsetTop;
	  var checkLeft = wrapperWidth + wrapperLeft - SVG_VALID_MARK_WIDTH + SVG_VALID_MARK_WIDTH_ADJUSTMENT;
	  var checkTop = wrapperHeight + wrapperTop - SVG_VALID_MARK_HALF_HEIGHT + SVG_VALID_MARK_HEIGHT_ADJUSTMENT;
	  svgValidEl.style.left = checkLeft + 'px';
	  svgValidEl.style.top = checkTop + 'px';
	};
	
	var _fadeValidMarkInOut = function _fadeValidMarkInOut() {
	  if (svgValidEl.classList.contains(VISIBLE_CSS_CLASS)) {
	    svgValidEl.classList.remove(VISIBLE_CSS_CLASS);
	  }
	  svgValidEl.classList.add(VISIBLE_CSS_CLASS);
	  setTimeout(function () {
	    svgValidEl.classList.remove(VISIBLE_CSS_CLASS);
	  }, 2000);
	};
	
	var markElementValid = function markElementValid(element) {
	  clearMarkers(element);
	  _positionValidMark(element);
	  _fadeValidMarkInOut();
	};
	
	// public api
	var validation = {
	  isValidNumber: isValidNumber,
	  markElementInvalid: markElementInvalid,
	  markElementValid: markElementValid,
	  clearMarkers: clearMarkers
	};
	
	exports.validation = validation;

/***/ },
/* 12 */
/*!*************************!*\
  !*** ./css/styles.scss ***!
  \*************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
/*!*************************!*\
  !*** ./sounds/ding.mp3 ***!
  \*************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b506a66a688dd0df4b191f1ff1611c45.mp3";

/***/ },
/* 14 */
/*!**************************!*\
  !*** ./sounds/tweet.mp3 ***!
  \**************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9a62c3d1f3ca4b470bc4a446f5c9c9e1.mp3";

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// bundle-68e43cae284c18f72682.js